// import { SubmitForm } from '../../../helper/formHelper';
import { getFormattedMsisdn } from '../../../helper/digitsHelper.js';
import languageKeys from 'constants/languageKeys'; 

export var startSubscribeMixin = {
  methods: {
    async startSubscribe() {
      this.loading = true;
      this.showError = false;

      //operator redirection = 1, OnlineUssd = 2, Undefined  = 0
      if (
        this.SubscribeFlowDetails.selectedOperator.operatorVerificationType == 1
      ) {
        let startSubscriptionRequest = {
          PaymentAccountNumber: this.mobileNumber ? this.textFieldPrefix.substring(1) + this.mobileNumber : '',
          PaymentProviderCode: this.SubscribeFlowDetails.selectedOperator.operatorCode,
          MerchantCustomerId: this.SubscribeFlowDetails.customerAccountNumber,
          SubscriptionPlanId: parseInt(this.SubscribeFlowDetails.subscriptionPlanId),
          ProductCatalog: this.SubscribeFlowDetails.catalogName,
          ProductSKU: this.SubscribeFlowDetails.initialProductSKU,
          Language: parseInt(Object.keys(languageKeys).find(key => languageKeys[key] === this.templateConfig.language)),
          SessionToken: this.sessionId,
          MerchantId: this.merchantConfig.merchantId,
          RedirectUrl: this.SubscribeFlowDetails.operatorRedirectionRedirectBackUrl
        };
        await window.TPay.Subscription.redirectToOperator(startSubscriptionRequest);
        return;
      }
      try {
        let response = await this.$http.post('/sub/SubscribeContract', {
          simulate: process.env.NODE_ENV === 'development' ? true : false,
          sessionToken: this.SubscribeFlowDetails.sessionToken,
        });
        /*========= response object Template ========== */
        // let response = {
        //   data: {
        //     operationStatusCode: '0',
        //     subscriptionContractId: 58,
        //     paymentTransactionStatusCode: '-1',
        //     transactionId: null,
        //     nextPaymentDate: '2021-11-16 20:58:22Z',
        //     errorMessage: `The customer has been activated recently and haven't consumed SAR 200 yet.`,
        //     subscriptionContractStatus: '1',
        //     msisdn: '0111500500',
        //     verificationMethod: null,
        //     verificationInstruction: null,
        //     charge: false,
        //     statusCode: 1,
        //     responseCode: 0,
        //   },
        // };
        /*============================================= */

        if (response.data.errorMessage) {
          switch (response.data.errorMessage) {
            case `The customer has been activated recently and haven't consumed SAR 200 yet.`:
              if (this.merchantConfig.fields[2].isEditable) {
                this.showErrorMessage(
                  this.$translate(`RESPONSECODE_${response.data.responseCode}`)
                );
              } else {
                this.moveToFailurePage(
                  this.$translate(`RESPONSECODE_${response.data.responseCode}`), //optional
                  response.data.responseCode
                );
              }
              break;
            case 'This user already subscribed to the given product':
            case 'This user already has active or pending subscription to the given product':
              this.moveToFailurePage(
                this.$translate('ALREADYSUBSCRIBED'), //optional
                response.data.responseCode
              );
              break;
            case 'Please enter valid phone number for the selected mobile operator.':
            case `This MSISDN is inactive at operator's side`:
              this.showErrorMessage(this.$translate('INVALIDMSISDN'));
              break;
            default:
              this.moveToFailurePage(
                this.$translate('GENERALERRORMESSAGE'), //optional
                response.data.operationStatusCode
              );
          }
        } else {
          //store (mobileNumber) to be showed in Sub-pincode step template.
          //store (transactionId) to be used in Sub-pincode resendPin() method.
          this.setSubscribeFlowDetails({
            transactionId: response.data.transactionId,
            msisdn:
              this.textFieldPrefix.substring(1) +
              getFormattedMsisdn(this.mobileNumber, this.textFieldPrefix),
          });

          this.moveToPincodeStep();
        }
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.loading = false;
      }
    },
    moveToFailurePage(msg, operationStatusCode) {
      this.setSubscribeFlowDetails({
        step: 4,
        component: 'SubFailure',
        failureMessage: msg,
        operationStatusCode,
      });
    },
    moveToPincodeStep() {
      this.setSubscribeFlowDetails({
        step: 2,
        component: 'SubPincode',
      });
    },
    showErrorMessage(msg) {
      this.error = msg;
      this.showError = true;
    },
  },
};
